import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Translate, I18n } from "react-redux-i18n";
import axios, { CancelToken } from "axios";
import { setAlert } from "../../../actions/alertActions";

class EditEnergyManagement extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      formState: {
        name: "",
        cpe: "",
        chargingMode: "",
        sharingMode: "",
        allowChargingModes: [],
        allowSharingModes: [],
        currentLimit: 0,
        solarMinimum: 0,
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (this.props.editOptionList) {
      this.setInitialFormState();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.editOptionList !== this.props.editOptionList) {
      this.setInitialFormState();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  setInitialFormState() {
    const { editOptionList } = this.props;
    if (editOptionList && this._mounted) {
      this.setState({
        formState: {
          name: editOptionList.general_name || "",
          cpe: editOptionList.general_cpe || "",
          chargingMode: editOptionList.chargingMode_energyManagement || "",
          sharingMode: editOptionList.sharingMode_energyManagement || "",
          allowChargingModes: editOptionList.allowChargingModes || [],
          allowSharingModes: editOptionList.allowSharingModes || [],
          currentLimit: editOptionList.currentLimit_energyManagement || 0,
          solarMinimum: editOptionList.solarMinimum_energyManagement || 0,
        },
      });
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    if (this._mounted) {
      this.setState((prevState) => ({
        formState: {
          ...prevState.formState,
          [name]: value,
        },
      }));
    }
  }

  handlePositiveNumberChange = (e) => {
    const { name, value } = e.target;
    if (value === "" || (Number(value) >= 0 && !isNaN(value))) {
      this.setState({
        formState: {
          ...this.state.formState,
          [name]: value,
        },
      });
    }
  };

  handleSave() {
    const params = {
      id: this.props.editOptionList.id,
      name: this.state.formState.name ? this.state.formState.name : "",
      cpe: this.state.formState.cpe ? this.state.formState.cpe : "",
      chargingMode: this.state.formState.chargingMode,
      minSolarCurrent: this.state.formState.solarMinimum
        ? this.state.formState.solarMinimum
        : this.props.solarMinimum_energyManagement,
      currentLimit: this.state.formState.currentLimit
        ? this.state.formState.currentLimit
        : this.props.currentLimit_energyManagement,
    };

    if (
      this.props.editOptionList.sharingMode_energyManagement &&
      this.state.formState.sharingMode
    ) {
      params.sharingMode = this.state.formState.sharingMode;
    }

    axios
      .patch(
        `/api/private/chargers/switchboard/${this.props.editOptionList.id}`,
        params,
        {
          cancelToken: new axios.CancelToken((c) => (this.cancel = c)),
        }
      )
      .then((res) => {
        this.props.setAlert(
          I18n.t("switchboarUpdateSuccess_EnergyManagement"),
          "primary"
        );
        this.setState({ editOptionList: res.data });
        this.props.refreshData();
        this.props.onHide();
      })
      .catch((err) => {
        this.props.setAlert(I18n.t(err.response.data.message), "danger");
      });
  }

  render() {
    const { formState } = this.state;
    const selectStyle = {
      borderColor: "#71778A",
      borderRadius: "20px",
    };

    return (
      <Modal
        id="editEnergyManagementModal"
        show={this.props.show}
        onHide={this.props.onHide}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Switchboard</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="general_name">
              <Form.Label>
                <Translate value="general_name" />
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={formState.name}
                onChange={this.handleChange}
              />
            </Form.Group>
            <Form.Group controlId="general_cpe">
              <Form.Label>
                <Translate value="general_cpe" />
              </Form.Label>
              <Form.Control
                type="text"
                name="cpe"
                value={formState.cpe}
                onChange={this.handleChange}
              />
            </Form.Group>
            {formState.allowChargingModes.length > 0 && (
              <Form.Group controlId="chargingMode_energyManagement">
                <Form.Label>
                  <Translate value="chargingMode_energyManagement" />
                </Form.Label>
                <Form.Control
                  as="select"
                  name="chargingMode"
                  value={formState.chargingMode}
                  onChange={this.handleChange}
                  style={selectStyle}
                >
                  {formState.allowChargingModes.map((mode, index) => (
                    <option key={index} value={mode}>
                      {mode}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            )}
            {formState.allowSharingModes.length > 0 && (
              <Form.Group controlId="sharingMode_energyManagement">
                <Form.Label>
                  <Translate value="sharingMode_energyManagement" />
                </Form.Label>
                <Form.Control
                  as="select"
                  name="sharingMode"
                  value={formState.sharingMode}
                  onChange={this.handleChange}
                  style={selectStyle}
                >
                  {formState.allowSharingModes.map((mode, index) => (
                    <option key={index} value={mode}>
                      {mode}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            )}
            {this.props.editOptionList.currentLimit_energyManagement !==
              null && (
              <Form.Group controlId="formCurrentLimit">
                <Form.Label>
                  <Translate value="currentLimit_energyManagement" />
                </Form.Label>
                <Form.Control
                  type="number"
                  name="currentLimit"
                  value={formState.currentLimit}
                  onChange={this.handlePositiveNumberChange}
                />
              </Form.Group>
            )}
            {this.props.editOptionList.solarMinimum_energyManagement !==
              null && (
              <Form.Group controlId="solarMinimum_energyManagement">
                <Form.Label>
                  <Translate value="solarMinimum_energyManagement" />
                </Form.Label>
                <Form.Control
                  type="number"
                  name="solarMinimum"
                  value={formState.solarMinimum}
                  onChange={this.handlePositiveNumberChange}
                />
              </Form.Group>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <button variant="primary" onClick={this.handleSave}>
            Update Switchboard
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  preferences: state.account.preferences,
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(EditEnergyManagement);
